import React, { useCallback, useEffect } from 'react';
import { VbzModal, VbzButton } from '@smiles/voebiz-ui-kit';
import { ModalBody } from 'reactstrap';
import { Trans, useTranslation } from 'react-i18next';
import { preventScroll } from '../../utils/modal';

type keyVal = {
  [key: string]: string;
};

export type IMessageType =
  | 'password_hint'
  | 'system_error'
  | 'new_password'
  | 'wrong_password'
  | 'contact'
  | 'email';

type IModalMessage = {
  idTitle?: string;
  idMessage?: Array<string>;
  idPrimaryButton?: string;
  idSecondaryButton?: string;
  valueOfField?: string;
  isLoading?: boolean;
  idValueOfField?: string;
  onClose?: (e: React.MouseEvent<Element, MouseEvent>) => void;
  isOpen?: boolean;
  onNext?: () => void;
  onSecondary?: () => void;
  type?: IMessageType;
  backdrop?: boolean;
  paramsMessage?: keyVal;
  IsDisabledBtnPrimary?: boolean;
};

const ModalMessage: React.FC<IModalMessage> = ({
  idTitle,
  idMessage,
  idPrimaryButton,
  idSecondaryButton,
  valueOfField,
  isLoading,
  idValueOfField,
  onClose,
  onNext,
  isOpen,
  type,
  backdrop,
  paramsMessage,
  onSecondary,
  children,
  IsDisabledBtnPrimary = false,
}) => {
  const { t } = useTranslation('messages');
  const message: Array<string> = t(`${type}.message`, { returnObjects: true });

  const text = useCallback(
    () => (
      <Trans
        id={idValueOfField}
        t={t}
        i18nKey={`${type}.message`}
        components={{ breakpoint: <br />, p: <p />, b: <b /> }}
        values={paramsMessage}
        tOptions={{ returnObjects: true }}
      />
    ),
    [idValueOfField, paramsMessage, t, type],
  );

  useEffect(() => {
    preventScroll(!!isOpen);
  }, [isOpen]);

  return (
    <VbzModal
      className={`smls-modal-my-account ${type}`}
      isOpen={isOpen}
      type="right"
      toggle={onClose}
      backdrop={backdrop}
    >
      <ModalBody>
        <div className="smls-modal-my-account-content">
          <h3 id={idTitle}>{t(`${type}.title`)}</h3>
          {message.length > 1 &&
            message.map((item, index) => (
              <p id={idMessage && idMessage[index]} key={item}>
                {item}
              </p>
            ))}
          {message.length <= 1 && <p id={idMessage && idMessage.length ? idMessage[0] : undefined}>{text()}</p>}
          {valueOfField && (
            <p id={idValueOfField} className="smls-bold">
              {valueOfField}
            </p>
          )}
        </div>
        {children}
        <div className="smls-modal-my-account-buttons">
          {!onNext && (
            <VbzButton
              id={idPrimaryButton}
              isLoading={false}
              text={t(`${type}.button`)}
              onClick={onClose}
              disabled={IsDisabledBtnPrimary}
            />
          )}
          {onNext && (
            <VbzButton
              id={idPrimaryButton}
              isLoading={isLoading}
              text={t(`${type}.button`)}
              onClick={onNext}
              disabled={IsDisabledBtnPrimary}
            />
          )}
          {onSecondary && (
            <VbzButton
              id={idSecondaryButton}
              isLoading={false}
              color="hyperlink"
              text={t(`${type}.btn-hyperlink`)}
              onClick={onSecondary}
              disabled={false}
            />
          )}
        </div>
      </ModalBody>
    </VbzModal>
  );
};

export default ModalMessage;
